import * as types from "./actionTypes";

const initialState = {
    isLoading: false,
    isError: false,
    lectures: [],
    allLectures:[],
    adminLecture: [],
    dailyLectures:[]

}

export const reducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.GET_DAILY_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false,
            }
        case types.GET_DAILY_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false,
                dailyLectures: payload,
                lectures:payload

            }
        case types.GET_DAILY_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true,
            }
        case types.SET_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case types.SET_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false
            }
        case types.SET_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case types.SET_BULK_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case types.SET_BULK_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false
            }
        case types.SET_BULK_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case types.EDIT_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case types.EDIT_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isError: false
            }
        case types.EDIT_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case types.GET_ADMIN_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case types.GET_ADMIN_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                adminLecture: action.payload.content,
                isError: false
            }
        case types.GET_ADMIN_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case types.POST_SEARCH_ADMIN_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: action.payload,
                isError: false
            }
        case types.POST_SEARCH_ADMIN_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                adminLecture: action.payload,
                isError: false
            }
        case types.POST_SEARCH_ADMIN_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: action.payload
            }
        case types.GET_SEARCH_LECTURES_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }
        case types.GET_SEARCH_LECTURES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                allLectures: payload,
                isError: false
            }
        case types.GET_SEARCH_LECTURES_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }
            case types.GET_ALL_LECTURE_REQUEST:
            return {
                ...state,
                isLoading: true,
                isError: false
            }
        case types.GET_ALL_LECTURE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                lectures: payload,
                isError: false
            }
        case types.GET_ALL_LECTURE_FAILURE:
            return {
                ...state,
                isLoading: false,
                isError: true
            }
        default:
            return state;
    }
}
